export default {
  club_name: 'Rosa Golfen',
  club_name_short: 'ringenas',
  stadium_name: '',
  staging_url: 'https://ringenas.api.fangroup.io',
  prod_url: 'https://ringenas.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/ringenas',
  club_logo: '/assets/teams/ringenas.png',
  app_name: 'ringenas',
  websale_name: 'ringenas',
  ntb_team_id: 10074,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'ringenas',
  monolithEnabled: false,
  clubWebsiteEnabled: true,
};
